// God save the Dev

'use strict';

/*if (process.env.NODE_ENV !== 'production') {
  require('./assets/templates/layouts/index.html');
  require('./assets/templates/layouts/services.html');
  require('./assets/templates/layouts/service-item.html');
  require('./assets/templates/layouts/calendar.html');
  require('./assets/templates/layouts/promo.html');
  require('./assets/templates/layouts/promo-item.html');
  require('./assets/templates/layouts/team.html');
  require('./assets/templates/layouts/course-short.html');
  require('./assets/templates/layouts/course-long.html');
  require('./assets/templates/layouts/blog.html');
  require('./assets/templates/layouts/blog-item.html');
  require('./assets/templates/layouts/teaching.html');
  require('./assets/templates/layouts/contacts.html');
}*/

// Depends
var $ = require('jquery');
require('bootstrap-sass');

// Modules
var Forms = require('_modules/forms');
var Slider = require('_modules/slider');
var Popup = require('_modules/popup');
var Fancy_select = require('_modules/fancyselect');
var Jscrollpane = require('_modules/jscrollpane');
var LightGallery = require('_modules/lightgallery');
var Jslider = require('_modules/jslider');
var Fancybox = require('_modules/fancybox');
require('../node_modules/jquery.nicescroll/jquery.nicescroll');
require('../node_modules/time-to/jquery.time-to.min.js');
require('_modules/succinct/succinct');
//require('../node_modules/sumoselect/jquery.sumoselect');

// Stylesheet entrypoint
require('_stylesheets/app.scss');

// Are you ready?
$(function() {
  new Forms();
  new Popup();
  new Fancy_select();
  new Jscrollpane();
  new LightGallery();
  new Slider();
  new Jslider();
  new Fancybox();

  setTimeout(function() { $('body').trigger('scroll'); }, 100);

  // language

  $('.header-lang > span').click(function() {
    $(this).next('ul').toggle();
    $('.header-currency > ul').hide();
    $('.header-contacts > div').hide();
    return false;
  });


  // currency

  $('.header-currency > span').click(function() {
    $(this).next('ul').toggle();
    $('.header-lang > ul').hide();
    $('.header-contacts > div').hide();
    return false;
  });

  // header contacts

  $('.header-contacts > span').click(function() {
    $(this).next('div').toggle();
    $('.header-lang > ul').hide();
    $('.header-currency > ul').hide();
    return false;
  });

  $(document).click(function() {
    $('.header-lang > ul').hide();
    $('.header-currency > ul').hide();
    $('.header-contacts > div').hide();
  });

  $(document).on('click', '.header-lang > ul', function(e) {
    e.stopPropagation();
  });

  $(document).on('click', '.header-currency > ul', function(e) {
    e.stopPropagation();
  });

  $(document).on('click', '.header-contacts > div', function(e) {
    e.stopPropagation();
  });

  // timer
    var time = $('.timer').data('time');
    var lang =  $('.timer').data('lang');
    $('.timer').timeTo({
    //timeTo: new Date('Thu Oct 06 2020 09:00:00 GMT+0300 (Восточная Европа, летнее время)'),
    timeTo: new Date(time),
    lang: lang,
    fontSize: 32,
    displayDays: 2,
    displayCaptions: true,
    captionSize: 16,
    countdown: true
  });

  // text truncating

  $('.blog-item__text > p').succinct({
    size: 125
  });

  $('.promo-item__text > p').succinct({
    size: 125
  });

  $('.blog-main__item-text > p').succinct({
    size: 125
  });

  $('.teaching-item__descr').succinct({
    size: 185
  });


    /*var description = $('.blog-item__text > p').html();

    if ($(window).width() < 480) {
        $('.blog-item__text > p').succinct({
            size: 400,
        })
    }
    else {
        $('.blog-item__text > p').html(description);
    }

    $(window).on('resize', function() {
        if ($(window).width() < 480) {
            $('.objavka-descr').succinct({
                size: 400,
            });
        }
        else {
            $('.objavka-descr').html(description);
        }
    });*/


  // mobile menu

  var touch = $('.mobile-menu__btn');
  var menu = $('.mobile-menu__wrapper');

  var toggles = document.querySelectorAll('.mobile-menu__btn');

  for (var i = toggles.length - 1; i >= 0; i--) {
    var toggle = toggles[i];
    toggleHandler(toggle);
  }

  function toggleHandler(toggle) {
    toggle.addEventListener( 'click', function(e) {
      e.preventDefault();
      (this.classList.contains('active') === true) ? this.classList.remove('active') : this.classList.add('active');
    });
  }

  $(touch).on('click', function(e) {
    e.preventDefault();
    menu.slideToggle();
    $('body').toggleClass('active');
  });

  // scroll

  $('.scroll-wrapper').niceScroll({
    cursorcolor: '#36bd1b',
    background: '#ebebeb',
    cursorborder: '0',
    cursorborderradius: '0',
    cursorwidth: '3px',
    horizrailenabled: false,
    autohidemode: false
  });

  $('.text-scroll').niceScroll({
    cursorcolor: '#008fe9',
    background: '#ebebeb',
    cursorborder: '0',
    cursorborderradius: '0',
    cursorwidth: '3px',
    horizrailenabled: false,
    autohidemode: false
  });

  setTimeout(function() {
    $('.scroll-wrapper').getNiceScroll().resize();
    $('.text-scroll').getNiceScroll().resize();
  }, 300);

  $('.popup-btn').click(function() {
    setTimeout(function() {
      $('.scroll-wrapper').getNiceScroll().resize();
      $('.nicescroll-rails').css('z-index', '10000').show();
    }, 300);
  });
  $('.mfp-close').on('click', function() {
    setTimeout(function() {
      $('scroll-wrapper').getNiceScroll().resize();
      $('.nicescroll-rails').css('z-index', 'auto').hide();
    }, 100);
  });
  $('.team-popup__btn').on('click', function() {
    setTimeout(function() {
      $('scroll-wrapper').getNiceScroll().resize();
      $('.nicescroll-rails').css('z-index', 'auto').hide();
    }, 100);
  });
  $('.popup-btn:not(.course-video)').magnificPopup({
    type: 'inline',
    callbacks: {
      close: function() {
        setTimeout(function() {
          $('scroll-wrapper').getNiceScroll().resize();
          $('.nicescroll-rails-vr').css('z-index', 'auto').hide();
        }, 100);
      }
    }
  });

  // courses

  $('.course-program__btn').on('click', function() {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active').find('span').html($(this).data('texthide')).closest('.section-course__program').find('.course-program__list > li:not(.visible)').slideDown();
    }
    else {
      $(this).removeClass('active').find('span').html($(this).data('textall')).closest('.section-course__program').find('.course-program__list > li:not(.visible)').slideUp();
    }
  });

  $('.course-cost__list-item').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');
  });

  // tabs

  $('.tabs').on('click', 'li:not(.active)', function() {
    $(this)
      .addClass('active').siblings().removeClass('active')
      .closest('.tabs-wrapper').find('.tabs-content').removeClass('active').eq($(this).index()).addClass('active');
  });

  // video

  /*$('.course-video').magnificPopup({
    items: {
      src: 'https://www.youtube.com/watch?v=ETpYjBQhc8s'
    },
    type: 'iframe'
  });*/

  // gallery

  $('.graduate-gallery').lightGallery({
    selector: '.insta-pic'
  });

  // scroll left/right on mobile

  $('.course-cost__list').each(function() {
    $(this).scroll(function() {
      var w = $(window).width();
      var el_w = $(this).find('li:first-child').width();
      var end = $(this).scrollLeft();
      console.log(end, el_w, w);
      $(this).closest('.course-cost__list-wrapper').addClass('begin');
      if (end === (el_w - w + 30)) {
        $(this).closest('.course-cost__list-wrapper').addClass('end').removeClass('begin');
      }
      else {
        $(this).closest('.course-cost__list-wrapper').removeClass('end').addClass('begin');
      }
      if (end > 0) {
        $(this).closest('.course-cost__list-wrapper').addClass('begin');
      }
      else {
        $(this).closest('.course-cost__list-wrapper').removeClass('begin');
      }
    });
  });

  // show more

  $('.btn-calendar').on('click', function() {
    if ($(this).closest('.section-calendar').find('.col-md-4:hidden').length > 0) {
      $(this).closest('.section-calendar').find('.col-md-4:hidden').slice(0, 6).slideDown();
    }
    else {
      $(this).hide();
    }
  });

  $('.blog-main__btn').on('click', function() {
    if ($(this).closest('.section-blog__main').find('.col-xs-12:hidden').length > 0) {
      $(this).closest('.section-blog__main').find('.col-xs-12:hidden').slice(0, 3).slideDown();
    }
    else {
      $(this).hide();
    }
  });

  // show hide text

  if ($('.course-about__text').length) {
      $('.course-about__text-show').show();
  }
  else {
      $('.course-about__text-show').hide();
  }

  setTimeout(function() {
      $('.course-about__text').each(function() {
          var c_h = $(this).height();
          console.log(c_h);
          $('.course-about__text-show').click(function() {
              $(this).toggleClass('active');
              $(this).html() == 'Показать все' ? $(this).html('Свернуть') : $(this).html('Показать все');
              if ($(this).hasClass('active')) {
                  $('.course-about__text-wrapper').css('height', c_h);
              }
              else {
                  $('.course-about__text-wrapper').css('height', 145);
              }
          });
      });
  }, 1000);

  // blog search

  $('.blog-main__search-btn').click(function() {
    $(this).next('form').toggleClass('active');
    return false;
  });

  $(document).click(function() {
    $('.blog-main__search-form').removeClass('active');
  });

  $(document).on('click', '.blog-main__search-form', function(e) {
    e.stopPropagation();
  });

  // lazy load
  var lazyload = function() {
    var scroll = $(window).scrollTop() + $(window).height() * 3;

    $('.lazy').each(function() {
      var $this = $(this);
      if ($this.offset().top < scroll) {
        $this.attr('src', $(this).data('original'));
      }
    });
    $('.lazy-web').each(function() {
      var $this = $(this);
      if ($this.offset().top < scroll) {
        $this.attr('srcset', $(this).data('original'));
      }
    });
  };
  $(window).scroll(lazyload);

  //remove main menu item link

  if(location.pathname == '/' || location.pathname == '/ua/'){
      jQuery('.menu-item-main a').replaceWith(function() {
          return jQuery('<span/>', {
              html: this.innerHTML
          });
      });
  }

  $('.mfp-hide form').on('sent', function () {
      $.magnificPopup.close();
  });

  $('#register-popup-noemail form').on('sent', function () {
      $(this).removeClass('disabled');
      var btntext = $(this).find('button[type="submit"]').html();
      $(this).find('button[type="submit"]').html(btntext);
  });

  $('.event-reg').on('click', function (e) {
      var eventid = jQuery(this).data('eventid');
      var data = new FormData();
      data.append( 'action',   'larus_event_register_form_action' );
      data.append( 'eventid',   eventid );

      $.ajax({
          url:         myajax.url,
          type:        'POST',
          data:        data,
          cache:       false,
          processData: false,
          contentType: false,
          dataType: 'json',
          success:     function(request){
              $('#register-popup-noemail .popup-title').html(request.form_title);
              $('#register-popup-noemail .popup-descr').html(request.title);
              $('#register-popup-noemail input[name="event"]').val(request.title);
          },
          error:       function(){
              console.log('Ошибка');
          }
      });
  });

  $('.header-currency a').on("click", function() {
      var date = new Date();
      var currency = $(this).data('currency');
      date.setTime(date.getTime() + 86400000);
      Cookies.set("currency", currency, { expires: date });
  });

    $(document).ready(function(){
        $('.register-price').on('click', function (e) {
            var eduFormats = $('.course-cost__content');

            var education = '';
            var cost = '';

            eduFormats.each(function(){
                if($(this).hasClass('active')) {
                    education = $(this).data('education');
                    cost = $(this).find('.course-cost__list-item.active').data('cost');
                }
            });

            $('#register-popup-prices').find('input[name="education"]').val(education);
            $('#register-popup-prices').find('input[name="cost"]').val(cost);
        });
    });
});



// WEBPACK FOOTER //
// ./app/app.js